// @TS-nocheck
import React, { useEffect, useState, useCallback, useReducer } from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col, Icon } from '@mch-group/uikit-components'
import classNames from 'classnames'
import { logger, validateAxiosResponse, uploadTransformationUrl } from '@dmi-mch/utils'
import { CustomLinkTag } from '@components'

import { GlobalStyles, Styles } from '@ot-modules/Press/ImagesModule.styles'
import { Text, SlickCarousel, CallToAction, HeadlineTitle, Separator } from '@components'
import { News as NewsService } from '@services'
import cssClasses from '@constants/cssClasses'
import { cmsPageUrl } from '@utils'
import { cloudinary } from '@constants'

const useForceUpdate = () => useReducer((state) => !state, false)[1]

const mID = 'otm-preview-articles'

const ArticleLinkWrapper = ({ children, href }) =>
  href ? (
    <CustomLinkTag url={href}>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a>{children}</a>
    </CustomLinkTag>
  ) : (
    [children]
  )

ArticleLinkWrapper.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string
}

const PreviewArticles = (props) => {
  const [articles, setArticles] = useState(null)
  const [sliderRef, setSliderRef] = useState(null)
  const [currentSlideCount, setCurrentSlideCount] = useState(1)

  // set the GRCPM - gallery related articles header title on the basis of the the domain
  const grcpmHeaderTitle = props.grcpm_title

  // auto detect gallery
  const autoDetect = props.grcpm_auto_detect_gallery === 'true'
  const galleryId = autoDetect ? props.pageMetaInfo.id : props.grcpm_related_gallery

  // entity request params
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const params = {
    limit: 5,
    offset: 0,
    type: 'NEWS_ARTICLE',
    orderBy: 'ORDER_BY_PUBLISHDATE',
    relationship: `GALLERY:${galleryId}:TALKS_ABOUT`,
    tagIds: props.grcpm_article_tag || null
  }

  const fetchArticles = useCallback(
    async (didUnmount = false) => {
      try {
        const req = await NewsService.search(params)
        if (!didUnmount && validateAxiosResponse(req)) {
          setArticles(req.data)
        }
      } catch (err) {
        !didUnmount && logger(err)
      }
    },
    [params]
  )

  // slider
  const initSlider = (ref) => !sliderRef && ref && setSliderRef(ref)
  const goPrevSlide = () => {
    sliderRef.slickPrev()
    setTimeout(() => {
      setCurrentSlideCount(sliderRef.innerSlider.state.currentSlide + 1)
    }, 500)
  }
  const goNextSlide = () => {
    sliderRef.slickNext()
    setTimeout(() => {
      setCurrentSlideCount(sliderRef.innerSlider.state.currentSlide + 1)
    }, 500)
  }

  const sliderSettings = {
    dots: false,
    arrows: false,
    swipeToSlide: true,
    afterChange: useForceUpdate(),
    onSwipe: (direction) => {
      if (direction === 'left') {
        goNextSlide()
      }
      if (direction === 'right') {
        goPrevSlide()
      }
    }
  }

  useEffect(() => {
    let didUnmount = false
    !articles && fetchArticles(didUnmount)
    return () => {
      didUnmount = true
    }
  }, [articles, fetchArticles])

  return articles && articles.items && articles.items.length > 0 ? (
    <>
      <Styles id={props.id} className={classNames(mID, props.className, cssClasses.CMS_MODULE)}>
        <Separator />
        <HeadlineTitle hch-grp1_title_style='title_style_2' hch-grp1_header={grcpmHeaderTitle} />
        <Container className='px-5 px-lg-8 px-md-7 mt-0'>
          <SlickCarousel settings={sliderSettings} setSliderRef={initSlider}>
            {articles.items.map((item) => (
              <div key={`${props.id}-${item.id}`}>
                <Row>
                  {item.imageUrl && (
                    <Col md={8} xs={12}>
                      <figure className='otm-latest-press-images__left-column'>
                        <ArticleLinkWrapper href={`/stories/${item.url}`}>
                          <img
                            src={uploadTransformationUrl(
                              item.imageUrl,
                              'w_1060,q_auto:good,dpr_1.0,ar_1.6,c_crop,c_fill,g_auto',
                              { transformUrl: cloudinary.throughCloudfront }
                            )}
                            alt={item.title}
                          />
                        </ArticleLinkWrapper>
                      </figure>
                    </Col>
                  )}
                  <Col md={4} xs={12}>
                    <div className='otm-latest-press-images__right-column'>
                      <ArticleLinkWrapper href={`/stories/${item.url}`}>
                        {item.title && <h3>{item.title}</h3>}
                        {item.description && (
                          <Text forwardedAs='p' isSmall className='otm-latest-press-images__copyright'>
                            {item.description}
                          </Text>
                        )}
                      </ArticleLinkWrapper>
                    </div>
                  </Col>
                </Row>
              </div>
            ))}
          </SlickCarousel>
          {articles.items.length > 1 && (
            <div className='slick__navigation'>
              <Row>
                <Col>
                  <div className='slick__navigation-controls'>
                    <a onClick={goPrevSlide} onKeyUp={goPrevSlide} role='link' tabIndex='0'>
                      <Icon name='chevron-left' className='slick__navigation-controls-caret' />
                    </a>
                    <div className='slick__navigation-controls-num'>
                      {sliderRef && <span className='slick__navigation-controls-num-first'>{currentSlideCount}</span>}
                      <span className='slick__navigation-controls-num-slash'> / </span>
                      <span className='slick__navigation-controls-num-last'>{articles.items.length}</span>
                    </div>
                    <a onClick={goNextSlide} onKeyUp={goNextSlide} role='link' tabIndex='-1'>
                      <Icon name='chevron-right' className='slick__navigation-controls-caret' />
                    </a>
                  </div>
                </Col>
              </Row>
            </div>
          )}
          {props.grcpm_call_to_action_link && props.grcpm_call_to_action_label && (
            <div className={classNames('otm-latest-press-images__more-grid')}>
              <Row className='otm-latest-press-images__more-row'>
                <Col>
                  <CallToAction
                    href={cmsPageUrl(props.grcpm_call_to_action_link)}
                    as={props.grcpm_call_to_action_link}
                    direction='chevron-right'
                    className='otm-latest-press-images__more otm-latest-press-images__more--inline'
                  >
                    {props.grcpm_call_to_action_label}
                  </CallToAction>
                </Col>
              </Row>
            </div>
          )}
        </Container>
      </Styles>
      <GlobalStyles />
    </>
  ) : null
}

PreviewArticles.propTypes = {
  grcpm_auto_detect_gallery: PropTypes.string,
  grcpm_call_to_action_label: PropTypes.string,
  grcpm_call_to_action_link: PropTypes.string,
  grcpm_title: PropTypes.string,
  grcpm_paris_title: PropTypes.string,
  grcpm_related_gallery: PropTypes.string,
  pageMetaInfo: PropTypes.object,
  className: PropTypes.string,
  grcpm_article_tag: PropTypes.string,
  id: PropTypes.number
}

export default PreviewArticles
